import { render, staticRenderFns } from "./MaterialsTable.vue?vue&type=template&id=598e75d2&scoped=true&lang=pug&"
import script from "./MaterialsTable.vue?vue&type=script&lang=js&"
export * from "./MaterialsTable.vue?vue&type=script&lang=js&"
import style0 from "./MaterialsTable.vue?vue&type=style&index=0&id=598e75d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598e75d2",
  null
  
)

export default component.exports